import type {Editor} from 'grapesjs';
import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import {AddBlockMenu} from '@Components/email-maker-block-manager/components/add-block-menu/add-block-menu';
import type {AddBlockMenuProps} from '@Components/email-maker-block-manager/components/add-block-menu/add-block-menu.types';
import {GrapesjsEditorContext} from '@Components/email-maker-block-manager/email-maker-block-manager-grapesjs-editor-context';

/** Mounts the add-element menu into a detached canvas-overlay container with its own React root + store. */
export function renderAddElementMenu(container: HTMLElement, opts: AddBlockMenuProps, editor: Editor): void {
  renderElement(
    container,
    <Provider store={window.PMW.redux.store}>
      <GrapesjsEditorContext.Provider value={editor}>
        <AddBlockMenu {...opts} />
      </GrapesjsEditorContext.Provider>
    </Provider>
  );
}
